<template>

    <authentication-layout :title="__('Secure Area')">

        <validation-errors class="mb-4" />

        <div class="mb-4 text-sm text-gray-600">
            {{ __('This is a secure area of the application. Please confirm your password before continuing.') }}
        </div>

        <form @submit.prevent="submit">

            <Input
                type="password"
                :placeholder="__('Password')"
                class="mt-1 block w-full"
                v-model="form.password"
                required
                autocomplete="current-password"
                autofocus
            />

            <div class="flex justify-start items-center">

                <Button class="mr-4"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">

                    {{ __('Confirm') }}

                </Button>

            </div>

        </form>

    </authentication-layout>

</template>

<script>
import { defineComponent } from 'vue';
import AuthenticationLayout from "@/Layouts/AuthenticationLayout";
import Button from '@/Components/Auth/Button.vue'
import Input from '@/Components/Auth/Input.vue'
import Label from '@/Components/Auth/Label.vue'
import ValidationErrors from '@/Components/Auth/ValidationErrors.vue'

export default defineComponent({
    components: {
        AuthenticationLayout,
        Button,
        Input,
        Label,
        ValidationErrors
    },

    data() {
        return {
            form: this.$inertia.form({
                password: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('password.confirm'), {
                onFinish: () => this.form.reset(),
            })
        }
    }
})
</script>
